import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import styles from './CustomCursor.module.scss';

// Small dot tracks instantly; ring follows on a spring and grows over links.
export default function CustomCursor() {
    const [enabled, setEnabled] = useState(false);
    const [hovering, setHovering] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const ringX = useSpring(x, { stiffness: 350, damping: 32, mass: 0.6 });
    const ringY = useSpring(y, { stiffness: 350, damping: 32, mass: 0.6 });

    useEffect(() => {
        const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!fine || reduce) return;
        setEnabled(true);

        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
            const interactive = e.target.closest('a, button, [role="button"]');
            setHovering(Boolean(interactive));
        };
        window.addEventListener('mousemove', move, { passive: true });
        return () => window.removeEventListener('mousemove', move);
    }, [x, y]);

    if (!enabled) return null;

    return (
        <>
            <motion.div className={styles.dot} style={{ x, y }} />
            <motion.div
                className={styles.ring}
                style={{ x: ringX, y: ringY }}
                animate={{ scale: hovering ? 1.9 : 1, opacity: hovering ? 0.9 : 0.5 }}
                transition={{ duration: 0.2 }}
            />
        </>
    );
}
